import React from 'react';

//components
import { ExternalLoginIcon, UserProfileImages } from 'thrive-components';

//helpers
import { Truncate } from  '@/helpers/Text';

//icons
import Icon from  '@/components/elements/icons/Icons';

//interfaces
import { IconLibrary } from  '@/interfaces/IconLibrary';
import { IGroupIconsAndName } from  '@/interfaces/orgSettings';



const GroupIconsAndName = ({profilePictures, userGroupId, userGroupName, hasNoMembers, truncate, isManagedGroup, externalLoginIcon}: IGroupIconsAndName) => {
    return (
        <span className='groupname-item bolder-text'>
            <div className="icon-wrapper">
                {hasNoMembers
                    ?   <Icon 
                            iconName={IconLibrary.USER_NONE} 
                            sizeInPx={'14'}
                        />
                    :   <UserProfileImages 
                            imageUrl={profilePictures} 
                            imageCap={4}
                        />
                }
            </div> 
            
            <a className='bolder-text user-link' href={`/admin/OrganizationUserGroup/UserGroupDetail/${userGroupId}`}>
                {Truncate(userGroupName, truncate)}

                {hasNoMembers && <span className='no-members'> (No Members)</span>}
            </a>

            {isManagedGroup &&
                <ExternalLoginIcon 
                    iconUrl={externalLoginIcon} 
                />
            }
        </span>
    )
}

export default GroupIconsAndName